import React from "react";
import tw, { styled } from "twin.macro";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useParallax } from "react-scroll-parallax";

const Div = tw.div`relative w-full max-w-[45rem]`;
const Background = styled.div(({ footer }) => [
  tw`relative w-full max-w-[35rem] lg:items-start flex flex-col items-center justify-center`,
  footer && tw`sm:items-start`,
]);
const Foreground = styled.div(({ footer }) => [
  tw`absolute top-[-5rem] max-w-[20rem] right-0 xl:right-[-5rem] hidden sm:flex`,
  footer && tw`right-4! xl:right-[5rem]! `,
]);

const Parallax = ({ background, foreground, footer, ...rest }) => {
  const { ref } = useParallax({
    speed: -10,
  });

  return (
    <Div {...rest}>
      <Background footer={footer}>
        {!!background?.localFile && (
          <GatsbyImage
            image={getImage(background.localFile)}
            alt={background.altText}
          />
        )}
      </Background>
      <Foreground ref={ref} footer={footer}>
        {!!foreground?.localFile && (
          <GatsbyImage
            image={getImage(foreground.localFile)}
            alt={foreground.altText}
          />
        )}
      </Foreground>
    </Div>
  );
};

export default Parallax;
